import { debounce, isElement, forEach } from 'lodash';
import 'jquery-validation';

import IsValidNgfMember from '../../03-api/validation/is-valid-ngf-member';

const moduleName = 'ngfmember-validation',
	selectors = {
		base: `.js-${moduleName}`
	};

class MemberValidation {

	constructor(baseElement) {
		if (!isElement(baseElement)) {
			console.error('No form was found');

			return;
		}

		this.element = baseElement;
		this.gsnElement = this.element.querySelector('#gsn');
		this.barcodeElement = this.element.querySelector('#barcode');
		this.errorContainer = this.element.querySelector('.field-validation-error');
		this.defaultError = this.errorContainer.dataset['valmsgDefault'];

		this._bindEvents();
	}

	_bindEvents() {
		const inputs = this.element.querySelectorAll('input');
		forEach(inputs, (input) => {
			input.addEventListener('change', debounce(this._inputHandler.bind(this), 250, { 'leading': false, 'trailing': true }));
			input.addEventListener('keyup', debounce(this._inputHandler.bind(this), 250, { 'leading': false, 'trailing': true }));
		});
	}

	_inputHandler() {
		this.gsn = this.gsnElement?.value;
		this.barcode = this.barcodeElement?.value;

		if (this.gsn !== '' && this.barcode !== '') {
				IsValidNgfMember(this.gsn, this.barcode)
					.done(result => {
						if (result.Error) {
							// do something about this error
							this.element.classList?.add('error');
							this.element.classList?.remove('valid');
							this.errorContainer.innerText = result.Error;
						}
						if (result.IsValid) {
							// hooray, happy happy, joy joy...
							this.element.classList?.remove('error');
							this.element.classList?.add('valid');
							this.errorContainer.innerText = '';
						}
						else {
							// show default error message
							this.element.classList?.add('error');
							this.element.classList?.remove('valid');
							this.errorContainer.innerText = this.defaultError;
						}
					});

				if (gsn === '' && barcode === '') {
					$(this.element).find('input').valid();

					this.element.classList?.remove('error');
					this.element.classList?.remove('valid');
					this.errorContainer.innerText = '';
			}
		}
	}
}

const initValidation = () => {
	forEach(document.querySelectorAll(selectors.base), (element) => {
		new MemberValidation(element);
	});
};

initValidation();